import {
  TrackEventResult,
  TrackEventType,
  Typenames,
} from '@varo/graphql-schema-types';
import { useCallback, useEffect, useState } from 'react';
import TrackEvent from 'services/graphql/mutations/Chat/TrackEvent';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { useMutation } from 'urql';

const useTrackEvent = () => {
  const { segmentClient } = useAnalyticsConfiguration();
  const [{ data }, refetchMutation] = useMutation<{
    trackEvent: TrackEventResult;
  }>(TrackEvent);
  const [trackedEvent, setTrackedEvent] = useState<TrackEventType | null>(null);

  useEffect(() => {
    if (data?.trackEvent.__typename === Typenames.TrackEventError) {
      void segmentClient.logEvent('Error Encountered', {
        name: `Failed to track event=${trackedEvent}`,
      });
    }
  }, [data, segmentClient, trackedEvent]);

  const trackEvent = useCallback(
    (event: TrackEventType) => {
      setTrackedEvent(event);
      void refetchMutation({
        input: {
          event,
        },
      });
    },
    [refetchMutation],
  );
  return { trackEvent };
};

export default useTrackEvent;
